var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticStyle:{"text-align":"center"}},[_vm._v(" 您无权限访问此内容，请联系管理员 ")])}
var staticRenderFns = []

export { render, staticRenderFns }